/*eslint no-warning-comments: "error"*/
/*eslint-disable sonarjs/cognitive-complexity*/
/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  github/no-blur */
/* eslint-disable  github/array-foreach */

import { controller } from "./controller";

@controller
class DatePickerElement extends HTMLElement {
  dayNames: string[] = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];
  dayOfWeekNames: string[] = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  monthNames: string[] = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  sundayFirst = false;
  persistOnSelect = false;
  longPressThreshold = 500;
  todayDate: Date = new Date();

  longPressInterval = 150;
  initDate: string | null = null;
  dateMax: string | null = null;
  dateMin: string | null = null;
  ignoreOnFocus = false;
  showCloseIcon = false;
  _inputStrIsValidDate = false;
  dateFormat: string | null = null;
  _longPressIntervalIds: number[] = [];
  _longPressTimerIds: number[] = [];
  _calTemplate = `
  <div id="calContainer" tabindex="0">
    <div id="calHeader">
      
     
      <div id="calTitle"></div>
      <div id="calCtrlPrevYear" class="calCtrl">&#9668;&#9668;</div>
      <div id="calCtrlPrevMonth" class="calCtrl">&#9668;</div>
      <div id="calCtrlNextMonth" class="calCtrl">&#9658;</div>
      <div id="calCtrlNextYear" class="calCtrl">&#9658;&#9658;</div>
      <div id="calCtrlHideCal" class="calCtrl">&#10005;</div>
    </div>
    <div id="calGrid">
      <div class="calDayName"></div>
      <div class="calDayName"></div>
      <div class="calDayName"></div>
      <div class="calDayName"></div>
      <div class="calDayName"></div>
      <div class="calDayName"></div>
      <div class="calDayName"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
      <div class="calDay"></div>
    </div>
    <div id="legend" class="legend"><div class="calSelectedDay"></div> Selected Date</div>
  </div>`;

  container: HTMLElement | undefined;
  calTitle: HTMLElement | undefined;
  calContainer: HTMLElement | undefined;
  dateObj: Date | undefined;
  displayedMonth = -1;
  displayedYear = -1;

  static get observedAttributes() {
    return [
      "init-date",
      "ignore-on-focus",
      "sunday-first",
      "persist-on-select",
      "show-close-icon",
      "date-format",
      "date-min",
      "date-max",
    ];
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (oldValue === newValue) {
      return;
    }

    if (name === "init-date") {
      this.initDate = newValue;
    } else if (name === "ignore-on-focus") {
      this.ignoreOnFocus = true;
    } else if (name === "sunday-first") {
      this.sundayFirst = true;
    } else if (name === "persist-on-select") {
      this.persistOnSelect = true;
    } else if (name === "show-close-icon") {
      this.showCloseIcon = true;
    } else if (name === "date-format") {
      this.dateFormat = newValue;
    } else if (name === "date-max") {
      this.dateMax = newValue;
    } else if (name === "date-min") {
      this.dateMin = newValue;
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    }, 0);
  }

  get textInputElement(): HTMLInputElement | undefined {
    return this.querySelector("input") as HTMLInputElement;
  }

  init() {
    if (this.textInputElement) {
      const mainContainer = document.createElement("div");
      mainContainer.style.display = "inline-block";
      if (this.container) {
        this.container.remove();
      }
      this.container = this.appendChild(mainContainer); // The returned value is the appended child

      const template = document.createElement("template");
      template.innerHTML = this._calTemplate;

      this.container.appendChild(this.textInputElement);
      this.container.appendChild(template.content);

      this.calTitle = this.querySelector("#calTitle") as HTMLElement;
      this.calContainer = this.querySelector("#calContainer") as HTMLElement;
      this.dateObj = new Date();
      let obj: any;

      if (this.initDate !== null) {
        obj = this._parseAndValidateInputStr(this.initDate);
        if (obj.valid) {
          this.dateObj = new Date(obj.year, obj.month, obj.day);
        }
        this._inputStrIsValidDate = true;
        this.textInputElement.value = this._returnDateString(this.dateObj);
      } else {
        obj = this._parseAndValidateInputStr(this.textInputElement.value);
        if (obj.valid) {
          this.dateObj = new Date(obj.year, obj.month, obj.day);
          this._inputStrIsValidDate = true;
        } else {
          this._inputStrIsValidDate = false;
        }
      }
      this.initDate = null;

      this.displayedMonth = this.dateObj.getMonth();
      this.displayedYear = this.dateObj.getFullYear();

      this.calContainer.style.display = "none";
      this._populateDayNames();
      this._addHeaderEventHandlers();
      this._renderCalendar();

      if (!this.ignoreOnFocus) {
        this.textInputElement.onfocus = this._inputOnFocusHandler;
        this.textInputElement.onfocus = this.textInputElement.onfocus.bind(this);
      }

      this.textInputElement.oninput = this._inputOnInputHandler;
      this.textInputElement.oninput = this.textInputElement.oninput.bind(this);

      this.textInputElement.onblur = this._blurHandler;
      this.textInputElement.onblur = this.textInputElement.onblur.bind(this);

      this.calContainer.onblur = this._blurHandler;
      this.calContainer.onblur = this.calContainer.onblur.bind(this);

      if (!this.showCloseIcon && this.querySelector("#calCtrlHideCal")) {
        (this.querySelector("#calCtrlHideCal") as HTMLElement).style.display = "none";
      }
    }
  }

  setFocusOnCal() {
    if (this.calContainer) {
      this.calContainer.style.display = "block";
      this.calContainer.focus();
    }
  }

  _dayClickedEventHandler(event: Event) {
    if (this.textInputElement) {
      this._inputStrIsValidDate = true;
      this._setNewDateValue((event.target as HTMLElement).innerHTML, this.displayedMonth, this.displayedYear);
      this.textInputElement.value = this.dateObj ? this._returnDateString(this.dateObj) : "";
      this.textInputElement.dispatchEvent(new CustomEvent("dateselect"));
      this._renderCalendar();
      if (!this.persistOnSelect) {
        this._hideCalendar();
      }
    }
  }

  _hideCalendar() {
    if (document.activeElement) {
      (document.activeElement as HTMLElement).blur();
    }
  }

  _calKeyDownEventHandler(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this._dayClickedEventHandler(event);
    }
  }

  _blurHandler() {
    // When the input element loses focus due to click on calContainer, new focus won't be directly set to calContainer, it is set to body.
    // After calContainer onclick, focus will be on body unless following delay is introduced:
    setTimeout(() => {
      checkActiveElement(this);
    }, 0);
    function checkActiveElement(ctx: DatePickerElement) {
      if (
        ctx &&
        ctx.calContainer &&
        ctx.textInputElement &&
        !(
          document.activeElement &&
          (document.activeElement.id === "calContainer" ||
            document.activeElement.classList.contains("calCtrl") ||
            document.activeElement.classList.contains("calDay") ||
            document.activeElement.isSameNode(ctx.textInputElement))
        )
      ) {
        ctx.calContainer.style.display = "none";
        ctx._mouseUpEventHandler();
        if (!ctx._inputStrIsValidDate && ctx.textInputElement) {
          ctx.textInputElement.dispatchEvent(new Event("invalid"));
        }
      }
    }
  }

  _addHeaderEventHandlers() {
    if (this.calContainer) {
      const entries = (this.calContainer.querySelectorAll(".calCtrl") as NodeListOf<HTMLElement>).entries();
      let entry = entries.next();
      while (entry.done === false) {
        entry.value[1].tabIndex = 0;
        entry.value[1].onblur = this._blurHandler;
        entry.value[1].onblur = entry.value[1].onblur.bind(this);
        entry.value[1].onclick = this._controlKeyDownEventHandler;
        entry.value[1].onclick = entry.value[1].onclick.bind(this);
        entry.value[1].onkeydown = this._controlKeyDownEventHandler;
        entry.value[1].onkeydown = entry.value[1].onkeydown.bind(this);
        entry.value[1].onmousedown = this._mouseDownEventHandler;
        entry.value[1].onmousedown = entry.value[1].onmousedown.bind(this);
        entry.value[1].onmouseup = this._mouseUpEventHandler;
        entry.value[1].onmouseup = entry.value[1].onmouseup.bind(this);
        entry.value[1].onmouseleave = this._mouseUpEventHandler;
        entry.value[1].onmouseleave = entry.value[1].onmouseleave.bind(this);
        entry.value[1].ontouchstart = this._mouseDownEventHandler;
        entry.value[1].ontouchstart = entry.value[1].ontouchstart.bind(this);
        entry.value[1].ontouchend = this._mouseUpEventHandler;
        entry.value[1].ontouchend = entry.value[1].ontouchend.bind(this);
        entry.value[1].ontouchcancel = this._mouseUpEventHandler;
        entry.value[1].ontouchcancel = entry.value[1].ontouchcancel.bind(this);
        entry = entries.next();
      }
    }
  }

  _startLongPressAction(event: Event) {
    this._longPressIntervalIds.push(
      setInterval(() => {
        this._controlKeyDownEventHandler(event);
      }, this.longPressInterval)
    );
    if (event.target && (event.target as HTMLElement).id && this.querySelector(`#${(event.target as HTMLElement).id}`))
      (this.querySelector(`#${(event.target as HTMLElement).id}`) as HTMLElement).onclick = () => {
        this._onClickHandlerAfterLongPress(event, this);
      };
  }

  // For better UX, after long press, onclick must be discarded once,
  // thus do nothing with the event and set clickhandler back to the real one:
  _onClickHandlerAfterLongPress(event: Event, ctx: any) {
    ctx.querySelector(`#${(event.target as HTMLElement).id}`).onclick = ctx._controlKeyDownEventHandler;

    ctx.querySelector(`#${(event.target as HTMLElement).id}`).onclick = ctx
      .querySelector(`#${(event.target as HTMLElement).id}`)
      .onclick.bind(ctx);
  }

  _mouseDownEventHandler(event: Event) {
    this._longPressTimerIds.push(
      setTimeout(() => {
        this._startLongPressAction(event);
      }, this.longPressThreshold)
    );
  }

  _mouseUpEventHandler() {
    this._longPressTimerIds.forEach(clearTimeout);
    this._longPressTimerIds = [];
    this._longPressIntervalIds.forEach(clearInterval);
    this._longPressIntervalIds = [];
  }

  _parseAndValidateInputStr(str: string) {
    const obj: any = {};
    let day, month, year;
    const value = new Date(str);
    if (!value.getDate()) {
      obj.valid = false;
    } else {
      day = value.getDate();
      month = value.getMonth() + 1;
      year = value.getFullYear();
      if (this._dateIsValid(day, month, year)) {
        obj.valid = true;
        obj.day = day;
        obj.month = month - 1;
        obj.year = year;
      } else {
        obj.valid = false;
      }
    }
    return obj;
  }

  _inputOnInputHandler() {
    const obj = this.textInputElement ? this._parseAndValidateInputStr(this.textInputElement.value) : null;

    if (obj && obj.valid && this.textInputElement) {
      this._inputStrIsValidDate = true;
      this._setNewDateValue(obj.day, obj.month, obj.year);
      this.displayedMonth = obj.month;
      this.displayedYear = obj.year;
      this.textInputElement.dispatchEvent(new CustomEvent("dateselect"));
      this._renderCalendar();
    } else {
      this._inputStrIsValidDate = false;
      //  if(this.textInputElement && this.textInputElement.value === ""){
      this._renderCalendar();
      // }
    }
  }

  _dateIsValid(day: number, month: number, year: number) {
    if (month < 1 || month > 12) {
      return false;
    }
    const last_day_of_month = this._daysInMonth(month, year);
    if (day < 1 || (last_day_of_month && day > last_day_of_month)) {
      return false;
    }
    return true;
  }

  _controlKeyDownEventHandler(event: Event) {
    if ((event as KeyboardEvent).key === "Enter" || event.type !== "keydown") {
      switch (event.target && (event.target as HTMLElement).id) {
        case "calCtrlPrevYear":
          this._showPrevYear();
          break;
        case "calCtrlNextYear":
          this._showNextYear();
          break;
        case "calCtrlPrevMonth":
          this._showPrevMonth();
          break;
        case "calCtrlNextMonth":
          this._showNextMonth();
          break;
        case "calCtrlHideCal":
          this._hideCalendar();
          break;
      }
    }
  }

  _inputOnFocusHandler() {
    this._inputOnInputHandler();
    if (this.calContainer) {
      this.calContainer.style.display = "block";
    }
  }

  _showNextYear() {
    this.displayedYear++;
    this._renderCalendar();
  }

  _showPrevYear() {
    this.displayedYear--;
    this._renderCalendar();
  }

  _showNextMonth() {
    if (this.displayedMonth === 11) {
      this.displayedMonth = 0;
      this.displayedYear++;
    } else {
      this.displayedMonth++;
    }
    this._renderCalendar();
  }

  _showPrevMonth() {
    if (this.displayedMonth === 0) {
      this.displayedMonth = 11;
      this.displayedYear--;
    } else {
      this.displayedMonth--;
    }
    this._renderCalendar();
  }

  _renderCalendar() {
    const tempDate = new Date(this.displayedYear, this.displayedMonth);
    tempDate.setDate(1);
    if (this.calTitle) {
      this.calTitle.textContent = `${this.monthNames[this.displayedMonth]} ${this.displayedYear}`;
    }
    const dayNumbers: number[] = [];
    const adjacentMonthDays: boolean[] = [];
    this._generateDayArray(tempDate, dayNumbers, adjacentMonthDays);
    let entries = this.calContainer
      ? (this.calContainer.querySelectorAll(".calDay") as NodeListOf<HTMLElement>).entries()
      : null;

    if (entries) {
      let entry = entries.next();
      while (entry.done === false) {
        entry.value[1].classList.remove("calAdjacentMonthDay");
        entry.value[1].classList.remove("calSelectedDay");
        entry.value[1].classList.remove("calHiddenRow");
        entry.value[1].classList.remove("calDisabledDate");
        entry.value[1].classList.remove("calTadaySelectedDay");
        entry.value[1].onclick = null;
        entry.value[1].onblur = null;
        entry.value[1].onkeydown = null;

        if (adjacentMonthDays[entry.value[0]]) {
          entry.value[1].classList.add("calAdjacentMonthDay");
        } else {
          entry.value[1].classList.add("calDayStyle");
        }
        entry.value[1].innerHTML = dayNumbers[entry.value[0]].toString();

        if (
          this.displayedMonth === this.todayDate.getMonth() &&
          this.displayedYear === this.todayDate.getFullYear() &&
          dayNumbers[entry.value[0]] === this.todayDate.getDate() &&
          !adjacentMonthDays[entry.value[0]]
        ) {
          entry.value[1].classList.add("calTadaySelectedDay");
        }
        if (
          this._inputStrIsValidDate &&
          this.dateObj &&
          this.displayedMonth === this.dateObj.getMonth() &&
          this.displayedYear === this.dateObj.getFullYear() &&
          dayNumbers[entry.value[0]] === this.dateObj.getDate() &&
          !adjacentMonthDays[entry.value[0]]
        ) {
          entry.value[1].classList.add("calSelectedDay");
        }
        if (!adjacentMonthDays[entry.value[0]]) {
          entry.value[1].onclick = this._dayClickedEventHandler;
          entry.value[1].onclick = entry.value[1].onclick.bind(this);
          entry.value[1].onkeydown = this._calKeyDownEventHandler;
          entry.value[1].onkeydown = entry.value[1].onkeydown.bind(this);
          entry.value[1].tabIndex = 0;
          entry.value[1].onblur = this._blurHandler;
          entry.value[1].onblur = entry.value[1].onblur.bind(this);
        } else {
          entry.value[1].removeAttribute("tabindex");
        }
        if (this.dateMin || this.dateMax) {
          const sDate = new Date(this.displayedYear, this.displayedMonth, Number(entry.value[1].innerHTML));
          const min: Date | null = this.dateMin ? new Date(this.dateMin) : null;
          const max: Date | null = this.dateMax ? new Date(this.dateMax) : null;
          if ((min && min > sDate) || (max && max < sDate)) {
            entry.value[1].classList.remove("calDayStyle");
            entry.value[1].classList.add("calDisabledDate");
            entry.value[1].onclick = null;
            entry.value[1].onblur = null;
            entry.value[1].onkeydown = null;
          }
        }
        entry = entries.next();
      }
    }

    // checking if last (=lowest) row of days are all adjacent month days:
    const lastSeven = adjacentMonthDays.slice(35, 42);
    if (lastSeven.every((x) => x === true)) {
      entries = this.calContainer
        ? (this.calContainer.querySelectorAll(".calDay") as NodeListOf<HTMLElement>).entries()
        : null;
      if (entries) {
        let entry = entries.next();
        while (entry.done === false) {
          if (entry.value[0] > 34) {
            entry.value[1].classList.add("calHiddenRow");
          }
          entry = entries.next();
        }
      }
    }
  }

  getDateString() {
    if (this._inputStrIsValidDate && this.dateObj) {
      return this._returnDateString(this.dateObj);
    }
    return null;
  }

  getDateObject() {
    if (this._inputStrIsValidDate) {
      return this.dateObj;
    }
    return null;
  }

  _setNewDateValue(day: string, month: number | null | undefined, year: number | null | undefined) {
    const _day = Number(day);
    const _month = Number(month);
    const _year = Number(year);
    if (
      this.dateObj &&
      (_day !== this.dateObj.getDate() || _month !== this.dateObj.getMonth() || _year !== this.dateObj.getFullYear())
    ) {
      // Order is important, always set year first:
      this.dateObj.setFullYear(_year);
      // Do not use setDate here:
      // this.dateObj.setDate(day) <-- https://stackoverflow.com/questions/14680396/the-date-getmonth-method-has-bug
      // Use setMonth with 2 params instead:
      this.dateObj.setMonth(_month, _day);
    }
  }

  _returnDateString(date: Date) {
    if (this.dateFormat) {
      return this.formatDate(date, this.dateFormat);
    } else {
      return new Intl.DateTimeFormat("en-US").format(date);
    }
  }

  formatDate(date: Date, patternStr: string) {
    if (!patternStr) {
      patternStr = "M/d/yyyy";
    }
    const day = date.getDate(),
      month = date.getMonth(),
      year = date.getFullYear(),
      hour = date.getHours(),
      minute = date.getMinutes(),
      second = date.getSeconds(),
      miliseconds = date.getMilliseconds(),
      h = hour % 12,
      hh = this.twoDigitPad(h),
      HH = this.twoDigitPad(hour),
      mm = this.twoDigitPad(minute),
      ss = this.twoDigitPad(second),
      aaa = hour < 12 ? "AM" : "PM",
      EEEE = this.dayOfWeekNames[date.getDay()],
      EEE = EEEE.substr(0, 3),
      dd = this.twoDigitPad(day),
      M = month + 1,
      MM = this.twoDigitPad(M),
      MMMM = this.monthNames[month],
      MMM = MMMM.substr(0, 3),
      yyyy = `${year}`,
      yy = yyyy.substr(2, 2);
    // checks to see if month name will be used
    patternStr = patternStr
      .replace("hh", hh.toString())
      .replace("h", h.toString())
      .replace("HH", HH.toString())
      .replace("H", hour.toString())
      .replace("mm", mm.toString())
      .replace("m", minute.toString())
      .replace("ss", ss.toString())
      .replace("s", second.toString())
      .replace("S", miliseconds.toString())
      .replace("dd", dd.toString())
      .replace("d", day.toString())

      .replace("EEEE", EEEE)
      .replace("EEE", EEE)
      .replace("yyyy", yyyy)
      .replace("yy", yy)
      .replace("aaa", aaa);
    if (patternStr.indexOf("MMM") > -1) {
      patternStr = patternStr.replace("MMMM", MMMM).replace("MMM", MMM);
    } else {
      patternStr = patternStr.replace("MM", MM.toString()).replace("M", M.toString());
    }
    return patternStr;
  }
  twoDigitPad(num: number) {
    return num < 10 ? `0${num}` : num;
  }
  _populateDayNames() {
    let dayNameArray = [];
    dayNameArray = this.dayNames.slice();
    if (this.sundayFirst) {
      dayNameArray.pop();
      dayNameArray.unshift(this.dayNames[6]);
    }

    const entries = this.calContainer ? this.calContainer.querySelectorAll(".calDayName").entries() : null;
    if (entries) {
      let entry = entries.next();
      while (entry.done === false) {
        entry.value[1].innerHTML = dayNameArray[entry.value[0]];
        entry = entries.next();
      }
    }
  }

  _generateDayArray(date: Date, dayArray: number[], adjacentMonthDaysArray: boolean[]) {
    let index;
    const dateDay = date.getDay();
    const dateMonth = date.getMonth() + 1;
    const dateYear = date.getFullYear();
    const daysInMonth = this._daysInMonth(dateMonth, dateYear);

    date.setDate(date.getDate() - 1);
    const prevMonth = date.getMonth() + 1;
    const prevMonthYear = date.getFullYear();
    let daysInPrevMonth: number | undefined = this._daysInMonth(prevMonth, prevMonthYear);

    // prev month day filling:
    if (daysInPrevMonth !== undefined) {
      if (this.sundayFirst) {
        for (index = 0; index < dateDay; index++) {
          dayArray.unshift(daysInPrevMonth);
          daysInPrevMonth--;
          adjacentMonthDaysArray.push(true);
        }
      } else {
        if (dateDay === 0) {
          for (index = 0; index < 6; index++) {
            dayArray.unshift(daysInPrevMonth);
            daysInPrevMonth--;
            adjacentMonthDaysArray.push(true);
          }
        } else {
          for (index = 0; index < dateDay - 1; index++) {
            dayArray.unshift(daysInPrevMonth);
            daysInPrevMonth--;
            adjacentMonthDaysArray.push(true);
          }
        }
      }
    }

    // current month day filling:
    if (daysInMonth) {
      for (index = 0; index < daysInMonth; index++) {
        dayArray.push(index + 1);
        adjacentMonthDaysArray.push(false);
      }
    }

    // next month day filling:
    const numberOfNextMonthDays = 42 - dayArray.length;
    for (index = 0; index < numberOfNextMonthDays; index++) {
      dayArray.push(index + 1);
      adjacentMonthDaysArray.push(true);
    }
  }

  _isItLeapYear(year: number) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  _daysInMonth(month: number, year: number) {
    if (month === 1 || month === 3 || month === 5 || month === 7 || month === 8 || month === 10 || month === 12) {
      return 31;
    } else if (month === 4 || month === 6 || month === 9 || month === 11) {
      return 30;
    } else if (month === 2 && this._isItLeapYear(year)) {
      return 29;
    } else if (month === 2 && !this._isItLeapYear(year)) {
      return 28;
    } else {
      return 31;
    }
  }
}

declare global {
  interface Window {
    DatePickerElement: typeof DatePickerElement;
  }
  interface HTMLElementTagNameMap {
    "date-picker": DatePickerElement;
  }
}

if (!window.customElements.get("date-picker")) {
  window.DatePickerElement = DatePickerElement;
  window.customElements.define("date-picker", DatePickerElement);
}
